import "./home.scss";
import {DEMO_CARDS} from "./demosConfig";
import {COMPONENTS_CARDS} from "./componentsConfig";
import FeatureCard from "../FeatureCard/FeatureCard";
import {ReactComponent as FlaskIcon} from "../../assets/icons/Flask.svg";
import {ReactComponent as RocketLaunchIcon} from "../../assets/icons/RocketLaunch.svg";
import {ReactComponent as EyeIcon} from "../../assets/icons/Eye.svg";

const HomePage = () => {
  return (
    <div className="home-container">
        <section className={"demos"}>
            <p className={"section-title"}>Applied AI</p>
            <div className={"two-column-container"}>
                {
                    DEMO_CARDS.map((card) => {
                        const {name, subtitle, disabled, testButton, deployButton, documentationLink} = card;
                        return <FeatureCard key={name.split(" ").join("-")} name={name} subtitle={subtitle} disabled={disabled}
                                            firstButtonName={"Test"}
                                            FirstButtonIcon={FlaskIcon}
                                            firstButtonDisabled={testButton.disable}
                                            firstButtonRedirect={testButton.redirectPath}

                                            secondButtonName={"Deploy"}
                                            SecondButtonIcon={RocketLaunchIcon}
                                            secondButtonDisabled={deployButton.disable}
                                            secondButtonRedirect={deployButton.redirectPath}
                                            documentationLink={documentationLink}
                                            showDocumentation={true}
                        />
                    })
                }
            </div>
        </section>

        <section className={"components"}>
            <p className={"section-title"}>Applied Components</p>
            <div className={"two-column-container"}>
                {
                    COMPONENTS_CARDS.map((card) => {
                        const {name, subtitle, disabled, testButton, viewButton, documentationLink} = card;
                        return <FeatureCard key={name.split(" ").join("-")} name={name} subtitle={subtitle} disabled={disabled}
                                            firstButtonName={"View"}
                                            FirstButtonIcon={EyeIcon}
                                            firstButtonDisabled={viewButton.disable}
                                            firstButtonRedirect={viewButton.redirectPath}

                                            secondButtonName={"Test"}
                                            SecondButtonIcon={FlaskIcon}
                                            secondButtonDisabled={testButton.disable}
                                            secondButtonRedirect={testButton.redirectPath}
                                            documentationLink={documentationLink}
                                            showDocumentation={false}
                        />
                    })
                }
            </div>
        </section>
        {/*<section className={"components"}>*/}
        {/*    <p className={"section-title"}>Components</p>*/}
        {/*    <ShowTestAndDeployCard cards={COMPONENTS_CARDS} showDocumentation={false}/>*/}
        {/*</section>*/}
    </div>
  );
};

export default HomePage;